<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="12">
        <v-card>
          <v-card-title v-if="!loading">
              {{ $t("servicesystem.common_objects.kpi.open_orders") }}
          </v-card-title>
          <v-card-title v-else>
            {{ $t("servicesystem.common_objects.fallbackterms.loading") }}
          </v-card-title>
          <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
          <v-card-text v-if="!loading">
            <DxDataGrid :data-source="gridSource" :show-borders="true" :hover-state-enabled="true"
              :customizeColumns="customizeColumns">
              <DxGroupPanel :visible="true" />
              <DxFilterRow :visible="true" />
              <DxGrouping :auto-expand-all="false" />
              <DxPaging :page-size="200" />
              <DxColumn data-field="JobStatus" :group-index="0" :auto-expand-group="true"
                :caption="$t('servicesystem.common_objects.job.status')">
              </DxColumn>
              <DxColumn :group-index="1" data-field="OrderId" :caption="$t('servicesystem.common_objects.order.order')">
              </DxColumn>
              <DxColumn data-field="DisplayName" :caption="$t('servicesystem.common_objects.job.job')">
              </DxColumn>
              <DxColumn data-field="MachineName" width="20%"
                :caption="$t('servicesystem.common_objects.machine.machine')">
              </DxColumn>
              <DxColumn data-field="CustomerName" :caption="$t('servicesystem.common_objects.customer.customer')">
              </DxColumn>
              <DxColumn data-field="ArticleNumber" width="10%"
                :caption="$t('servicesystem.common_objects.article.article')">
              </DxColumn>
              <DxColumn data-field="ArticleCount" :caption="$t('servicesystem.common_objects.order.count')"
                data-type="number" width="10%">
              </DxColumn>
              <DxColumn data-field="ArticleDescription" width="15%"
                :caption="$t('servicesystem.common_objects.order.description')">
              </DxColumn>
              <DxColumn data-field="TotalAmountExclVat" :caption="$t('servicesystem.common_objects.kpi.total')"
                data-type="number"
                :format="{ type: 'currency', precision: 2, currency: $store.state.GlobalSettings.CurrencyFormat }">
              </DxColumn>

              <DxSummary :calculate-custom-summary="calculateCustomSummary" :skip-empty-values="true">
                <DxGroupItem name="TotalAmountExclVat" :customizeText="sumFormatText" summary-type="sum"
                  column="TotalAmountExclVat" :show-in-group-footer="true" :align-by-column="true" />
                <DxGroupItem :customizeText="sumFormatText" summary-type="sum" column="TotalAmountExclVat"
                  :show-in-group-footer="false" :align-by-column="true" />
                <DxGroupItem name="CustomerName" :align-by-column="true" :customizeText="sumFormatCustomerName"
                  summary-type="custom" column="CustomerName" :show-in-group-footer="false" />
                <DxGroupItem name="MachineName" :align-by-column="true" :customizeText="sumFormatCustomerName"
                  summary-type="custom" column="MachineName" :show-in-group-footer="false" />
              </DxSummary>

              <DxSortByGroupSummaryInfo summary-item="CustomerName" />
              <DxColumn type="buttons" :width="60">
                <DxButton text="Ok" :hint="$t('servicesystem.common_objects.commonterms.open')" icon="arrowright"
                  :on-click="openJob">
                </DxButton>
              </DxColumn>
            </DxDataGrid>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <h4 class="pr-5">
              {{ $t('servicesystem.common_objects.kpi.total') }}:<br />
              {{ this.$store.state.GlobalSettings.CurrencyFormat }} {{ total }}
            </h4>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import client from "@/api/client";
import DxDataGrid, { DxButton, DxColumn, DxFilterRow, DxGrouping, DxGroupItem, DxGroupPanel, DxPaging, DxSortByGroupSummaryInfo, DxSummary } from "devextreme-vue/data-grid";
export default {
  name: "TimeReport",
  props: [],
  components: {
    DxButton, DxColumn, DxFilterRow, DxDataGrid, DxSortByGroupSummaryInfo, DxPaging, DxGroupPanel, DxSummary, DxGroupItem, DxGrouping
  },
  data() {
    return {
      loading: true,
      items: null,
      gridSource: null,
      columns: [],
      groupSelection: ["Closed", "Completed", "Planned", "Created"],
      statusSelection: ["Closed", "Completed", "Planned", "Created"],
    };
  },
  mounted() {
    this.getData()
  },
  methods: {
    customizeColumns(columns) {
      columns.forEach(c => { c.cssClass = 'dxHeader' })
    },
    sumFormatText(options) {
      return this.$store.state.GlobalSettings.CurrencyFormat + ' ' + (new Intl.NumberFormat().format(options.value.toFixed(2)))
    },
    sumFormatCustomerName(options) {
      if (options.value == undefined) {
        return null
      }
      return options.value
    },
    getData() {
      this.loading = true;
      this.items = null;
      this.gridSource = null;
      client()
        .get(`/api2/serviceprovider/statistics/open-orders`)
        .then((response) => {
          this.gridSource = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    customizeTooltip(args) {
      return {
        text: `${args.argument.toLocaleDateString()}<br/>${args.seriesName}: ${args.value}`
      }
    },
    openJob(args) {
      const routeData = this.$router.resolve({ name: 'ViewJobInvoice', params: { filter: 'my', jobId: args.row.data.ParentJobId } });
      window.open(routeData.href, '_blank');
    },
    calculateCustomSummary(options) {
      if (options.name == 'CustomerName') {
        switch (options.summaryProcess) {
          case "start":
            options.customers = []
            // Initializing "totalValue" here
            break;
          case "calculate":
            if (options.customers.indexOf(options.value) < 0) {
              options.customers.push(options.value)
            }
            if (options.groupIndex == 1) {
              options.totalValue = options.value
            }
            break;
          case "finalize":
            // Assigning the final value to "totalValue" here
            if (options.groupIndex == 0) {
              options.totalValue = `(${options.customers.length} ${this.$t('servicesystem.common_objects.customer.customers')})`
            }
            break;
        }
      }
      if (options.name == 'MachineName') {
        switch (options.summaryProcess) {
          case "start":
            // Initializing "totalValue" here
            options.machines = []
            break;
          case "calculate":
            if (options.machines.indexOf(options.value) < 0) {
              options.machines.push(options.value)
            }
            if (options.groupIndex == 1) {
              options.totalValue = options.value
            }
            break;
          case "finalize":
            // Assigning the final value to "totalValue" here
            if (options.groupIndex == 1) {
              if (options.machines.length > 1) {
                options.totalValue = `${options.machines.length} ${this.$t('servicesystem.common_objects.machine.machines')}`
              }
            }
            else if (options.groupIndex == 0) {
              options.totalValue = `(${options.machines.length} ${this.$t('servicesystem.common_objects.machine.machines')})`
            }
            break;
        }
      }
    }
  },

  computed: {
    total() {
      if (this.gridSource) {
        const totalAmounts = this.gridSource.reduce((p, c) => p + c.TotalAmountExclVat, 0)
        return (new Intl.NumberFormat().format(totalAmounts.toFixed(2)))
      }
      return 0;
    }
  },

  watch: {},
};
</script>


<style lang='scss'>
.dxHeader .dx-datagrid .dx-datagrid-headers .dx-header-filter,
.dx-datagrid .dx-datagrid-headers .dx-header-row>td {
  font-size: 1.1em !important;
  font-weight: bold;
  color: var(--v-dark-text-lighten4);
  padding-top: 16px;
  padding-bottom: 16px;
}

.dxHeader .dx-datagrid .dx-datagrid-headers .dx-header-filter,
.dx-datagrid .dx-datagrid-headers .dx-header-row>td:hover {
  background-color: var(--v-contentboxBackground-base);
  ;
}
</style>